module.exports = __webpack_public_path__ + "static/img/u107.995f817.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/clay/u107.png
// module id = +z3V
// module chunks = 0